import React, {ReactElement, useMemo} from 'react';
import {Helmet as ReactHelmet} from 'react-helmet';
import {useUserContext} from 'shared/contexts/UserContext/useUserContext';
import getTrackingScripts from './getTrackingScripts';

function Helmet(): ReactElement | null {
  const {user} = useUserContext();
  const scripts = useMemo(() => getTrackingScripts(user), [user]);
  return <ReactHelmet script={scripts} />;
}

export default Helmet;
